import { render, staticRenderFns } from "./PageSelforderingLogin.vue?vue&type=template&id=125fca15&"
import script from "./PageSelforderingLogin.vue?vue&type=script&lang=js&"
export * from "./PageSelforderingLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/madamesumcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('125fca15')) {
      api.createRecord('125fca15', component.options)
    } else {
      api.reload('125fca15', component.options)
    }
    module.hot.accept("./PageSelforderingLogin.vue?vue&type=template&id=125fca15&", function () {
      api.rerender('125fca15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/madamesum/js/pages/PageSelforderingLogin.vue"
export default component.exports